<template>
  <div>
    <h1>{{ $route.meta.title }}</h1>
    <SubstituteAdh
      :members="
        selectedMember && selectedMember.Level == 3 ? [selectedMember] : members
      "
      :selectedMemberGuid="selectedMemberGuid"
      @update="selectedMemberGuid = $event"
    ></SubstituteAdh>
    <div class="d-flex justify-content-center mt-5">
      <div class="newsletter-content">
        <section>
          <img
            class="header-img"
            src="@/assets/newsletter-header.png"
            alt="CMEM header image"
          />
        </section>
        <section>
          <p>
            Bonjour
            <span class="color-primary"
              >{{ $store.state.self.firstname }}
              {{ $store.state.self.name }}</span
            >
          </p>
          <p>
            Vous trouverez ci-dessous vos éléments de RFA actualisés en date du
            <span class="color-primary">{{ datas.sendDate }}</span>
          </p>
        </section>

        <!--Données Annuelles-->
        <section class="block-container">
          <div class="block-section">
            <h2>Mes RFA annuelles en cours</h2>
            sur base des enregistrements {{ datas.rfaYearN1 }} en cours
            <div v-if="nlInfos.Infos" class="block-3-container">
              <DataBlock
                :title="'CA ' + datas.rfaYearN1"
                :progress="nlInfos.Infos.ProgCaAnnuel"
                :isProgressPercent="true"
                :value="datas.valCaN1"
                :isValuePercent="false"
                :gray="true"
              />
              <DataBlock
                :title="'RFA ' + datas.rfaYearN1"
                :progress="nlInfos.Infos.ProgRfaAnnuel"
                :value="datas.valRfaN1"
                :isProgressPercent="true"
                :isValuePercent="false"
                :gray="true"
              />
              <DataBlock
                :title="'Tx Global ' + datas.rfaYearN1"
                :progress="nlInfos.Infos.ProgTxRfaAnnuel"
                :isProgressPercent="false"
                :value="datas.valTxRfaN1"
                :isValuePercent="true"
                :gray="true"
              />
            </div>
          </div>
          <div class="block-section">
            <h2>Mes RFA annuelles projetées</h2>
            {{ datas.rfaNSavedLibelle }}
            <div v-if="nlInfos.Projection" class="block-3-container">
              <DataBlock
                :title="'CA ' + datas.rfaYearN1"
                :progress="nlInfos.Projection.ProgCaAnnuel"
                :value="datas.valCaProj"
                :isProgressPercent="true"
                :isValuePercent="false"
                :gray="true"
              />
              <DataBlock
                :title="'RFA ' + datas.rfaYearN1"
                :progress="nlInfos.Projection.ProgRfaAnnuel"
                :value="datas.valRfaProj"
                :isProgressPercent="true"
                :isValuePercent="false"
                :gray="true"
              />
              <DataBlock
                :title="'Tx Global ' + datas.rfaYearN1"
                :progress="nlInfos.Projection.ProgTxRfaAnnuel"
                :value="datas.valTxRfaProj"
                :isProgressPercent="false"
                :isValuePercent="true"
                :gray="true"
              />
            </div>
          </div>
        </section>

        <!--Donnees acomptes-->
        <section class="block-container">
          <div class="block-section">
            <h2>Mes acomptes (T1 {{ datas.rfaYearN }})</h2>
            <div
              v-if="nlInfos.Infos && datas.count >= 2"
              class="block-3-container"
            >
              <DataBlock
                :title="'CA ' + datas.rfaYearN"
                :progress="nlInfos.Infos.ProgCaT1"
                :value="datas.valCaT1"
                :isProgressPercent="true"
                :isValuePercent="false"
                :gray="false"
              />
              <DataBlock
                :title="'RFA ' + datas.rfaYearN"
                :progress="nlInfos.Infos.ProgRfaT1"
                :value="datas.valRfaT1"
                :isProgressPercent="true"
                :isValuePercent="false"
                :gray="false"
              />
              <DataBlock
                :title="'Tx Global ' + datas.rfaYearN"
                :progress="nlInfos.Infos.ProgTxRfaT1"
                :value="datas.valTxRfaT1"
                :isProgressPercent="false"
                :isValuePercent="true"
                :gray="false"
              />
            </div>
            <Placeholder v-else :date="limitDates[0] + '/' + datas.rfaYearN" />
          </div>
          <div class="block-section">
            <h2>Mes acomptes (T2 {{ datas.rfaYearN }})</h2>
            <div
              v-if="nlInfos.Infos && datas.count >= 3"
              class="block-3-container"
            >
              <DataBlock
                :title="'CA ' + datas.rfaYearN"
                :progress="nlInfos.Infos.ProgCaT2"
                :value="datas.valCaT2"
                :isProgressPercent="true"
                :isValuePercent="false"
                :gray="false"
              />
              <DataBlock
                :title="'RFA ' + datas.rfaYearN"
                :progress="nlInfos.Infos.ProgRfaT2"
                :value="datas.valRfaT2"
                :isProgressPercent="true"
                :isValuePercent="false"
                :gray="false"
              />
              <DataBlock
                :title="'Tx Global ' + datas.rfaYearN"
                :progress="nlInfos.Infos.ProgTxRfaT2"
                :value="datas.valTxRfaT2"
                :isProgressPercent="false"
                :isValuePercent="true"
                :gray="false"
              />
            </div>
            <Placeholder v-else :date="limitDates[1] + '/' + datas.rfaYearN" />
          </div>
          <div class="block-section">
            <h2>Mes acomptes (T3 {{ datas.rfaYearN }})</h2>
            <div
              v-if="nlInfos.Infos && datas.count >= 4"
              class="block-3-container"
            >
              <DataBlock
                :title="'CA ' + datas.rfaYearN"
                :progress="nlInfos.Infos.ProgCaT3"
                :value="datas.valCaT3"
                :isProgressPercent="true"
                :isValuePercent="false"
                :gray="false"
              />
              <DataBlock
                :title="'RFA ' + datas.rfaYearN"
                :progress="nlInfos.Infos.ProgRfaT3"
                :value="datas.valRfaT3"
                :isProgressPercent="true"
                :isValuePercent="false"
                :gray="false"
              />
              <DataBlock
                :title="'Tx Global ' + datas.rfaYearN"
                :progress="nlInfos.Infos.ProgTxRfaT3"
                :value="datas.valTxRfaT3"
                :isProgressPercent="false"
                :isValuePercent="true"
                :gray="false"
              />
            </div>
            <Placeholder v-else :date="limitDates[2] + '/' + datas.rfaYearN" />
          </div>
          <div class="block-section">
            <h2>Mon total acompte {{ datas.rfaYearN }}</h2>
            <div
              v-if="nlInfos.Infos && datas.count >= 2"
              class="block-3-container"
            >
              <DataBlock
                :title="'CA ' + datas.rfaYearN"
                :progress="nlInfos.Infos.ProgCaAcompte"
                :value="datas.valCaAcompte"
                :isProgressPercent="true"
                :isValuePercent="false"
                :gray="false"
              />
              <DataBlock
                :title="'RFA ' + datas.rfaYearN"
                :progress="nlInfos.Infos.ProgRfaAcompte"
                :value="datas.valRfaAcompte"
                :isProgressPercent="true"
                :isValuePercent="false"
                :gray="false"
              />
              <DataBlock
                :title="'Tx Global ' + datas.rfaYearN"
                :progress="nlInfos.Infos.ProgTxRfaAcompte"
                :value="datas.valTxRfaAcompte"
                :isProgressPercent="false"
                :isValuePercent="true"
                :gray="false"
              />
            </div>
            <Placeholder v-else :date="limitDates[0] + '/' + datas.rfaYearN" />
          </div>
        </section>

        <!--Top familles et frs-->
        <section class="block-container">
          <!--TOP 3 Familles-->
          <div class="block-section">
            <h2>Mon TOP 3 familles</h2>
            <span
              >Proportion sur base des enregistrements {{ datas.rfaYearN1 }} en
              cours</span
            >
            <div class="block-3-container">
              <div class="top-block-container">
                {{ datas.top1FamLabel }}
                <span
                  class="rank-progress"
                  :style="{ backgroundColor: datas.top1FamRankProgressColor }"
                  >{{ datas.top1FamRankProgress }}</span
                >
                {{ datas.top1FamProp }}%
              </div>
              <div class="top-block-container">
                {{ datas.top2FamLabel }}
                <span
                  class="rank-progress"
                  :style="{ backgroundColor: datas.top2FamRankProgressColor }"
                  >{{ datas.top2FamRankProgress }}</span
                >
                {{ datas.top2FamProp }}%
              </div>
              <div class="top-block-container">
                {{ datas.top3FamLabel }}
                <span
                  class="rank-progress"
                  :style="{ backgroundColor: datas.top3FamRankProgressColor }"
                  >{{ datas.top3FamRankProgress }}</span
                >
                {{ datas.top3FamProp }}%
              </div>
            </div>
          </div>

          <!--TOP 3 Fournisseur-->
          <div class="block-section">
            <h2>Mon TOP 3 fournisseur</h2>
            <span
              >Proportion sur base des enregistrements {{ datas.rfaYearN1 }} en
              cours</span
            >
            <div class="block-3-container">
              <div class="top-block-container">
                {{ datas.top1FrsLabel }}
                <span
                  class="rank-progress"
                  :style="{ backgroundColor: datas.top1FrsRankProgressColor }"
                  >{{ datas.top1FrsRankProgress }}</span
                >
                {{ datas.top1FrsProp }}%
              </div>
              <div class="top-block-container">
                {{ datas.top2FrsLabel }}
                <span
                  class="rank-progress"
                  :style="{ backgroundColor: datas.top2FrsRankProgressColor }"
                  >{{ datas.top2FrsRankProgress }}</span
                >
                {{ datas.top2FrsProp }}%
              </div>
              <div class="top-block-container">
                {{ datas.top3FrsLabel }}
                <span
                  class="rank-progress"
                  :style="{ backgroundColor: datas.top3FrsRankProgressColor }"
                  >{{ datas.top3FrsRankProgress }}</span
                >
                {{ datas.top3FrsProp }}%
              </div>
            </div>
          </div>
        </section>

        <!--Données simulateur-->
        <!--Top simulation baisse-->
        <section class="block-container">
          <h2 class="block-title">Simulation RFA individuelle</h2>
          <div class="block-section">
            <h2>Alertes baisse</h2>
            <table v-if="nlInfos.TopAlerteBaisse && datas.count >= 3">
              <thead>
                <tr>
                  <td v-if="nlInfos.AdhLevel == 2">Société</td>
                  <td>Fournisseur</td>
                  <td>Perte CA</td>
                  <td>Perte Taux</td>
                  <td>Perte RFA</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(top, i) of nlInfos.TopAlerteBaisse"
                  :key="'top-alerte-' + i"
                >
                  <td v-if="nlInfos.AdhLevel == 2">{{ top.SocietyName }}</td>
                  <td>{{ datas["top" + (i + 1) + "SimBaisseLabel"] }}</td>
                  <td>{{ datas["top" + (i + 1) + "SimBaissePerteCA"] }}€</td>
                  <td>{{ datas["top" + (i + 1) + "SimBaissePerteTx"] }}%</td>
                  <td :class="{ green: top.Rfa > 0, red: top.Rfa < 0 }">
                    {{ datas["top" + (i + 1) + "SimBaissePerteRFA"] }}€
                  </td>
                </tr>
              </tbody>
            </table>
            <Placeholder v-else :date="limitDates[1] + '/' + datas.rfaYearN" />
          </div>

          <!--Top Gain palier sup. par RFA-->
          <div class="block-section">
            <h2>Top gain palier sup. par RFA</h2>
            <table v-if="nlInfos.TopPalierSupRfa && datas.count >= 3">
              <thead>
                <tr>
                  <td v-if="nlInfos.AdhLevel == 2">Société</td>
                  <td>Fournisseur</td>
                  <td>Manque CA</td>
                  <td>RFA</td>
                  <td>Rentabilité</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(top, i) of nlInfos.TopPalierSupRfa"
                  :key="'top-palier-sup-rfa-' + i"
                >
                  <td v-if="nlInfos.AdhLevel == 2">{{ top.SocietyName }}</td>
                  <td>{{ datas["top" + (i + 1) + "PalierSupRFALabel"] }}</td>
                  <td>{{ datas["top" + (i + 1) + "PalierSupRFACA"] }}€</td>
                  <td>{{ datas["top" + (i + 1) + "PalierSupRFA"] }}€</td>
                  <td
                    :class="{
                      green: top.PalierRentabilite > 0,
                      red: top.PalierRentabilite < 0
                    }"
                  >
                    {{ datas["top" + (i + 1) + "PalierSupRFARenta"] }}%
                  </td>
                </tr>
              </tbody>
            </table>
            <Placeholder v-else :date="limitDates[1] + '/' + datas.rfaYearN" />
          </div>

          <!--Top Gain palier sup. par rentabilité-->
          <div class="block-section">
            <h2>Top gain sup. par rentabilité</h2>
            <table v-if="nlInfos.TopPalierSupRentabilite && datas.count >= 3">
              <thead>
                <tr>
                  <td v-if="nlInfos.AdhLevel == 2">Société</td>
                  <td>Fournisseur</td>
                  <td>Manque CA</td>
                  <td>RFA</td>
                  <td>Rentabilité</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(top, i) of nlInfos.TopPalierSupRentabilite"
                  :key="'top-palier-sup-rfa-' + i"
                >
                  <td v-if="nlInfos.AdhLevel == 2">{{ top.SocietyName }}</td>
                  <td>{{ datas["top" + (i + 1) + "PalierSupRentaLabel"] }}</td>
                  <td>{{ datas["top" + (i + 1) + "PalierSupRentaCA"] }}€</td>
                  <td>{{ datas["top" + (i + 1) + "PalierSupRentaRFA"] }}€</td>
                  <td
                    :class="{
                      green: top.PalierRentabilite > 0,
                      red: top.PalierRentabilite < 0
                    }"
                  >
                    {{ datas["top" + (i + 1) + "PalierSupRenta"] }}%
                  </td>
                </tr>
              </tbody>
            </table>
            <Placeholder v-else :date="limitDates[1] + '/' + datas.rfaYearN" />
          </div>

          <!--Bon à savoir-->
          <div class="block-section">
            <h2>Bon à savoir</h2>
            <img
              class="img-bon-a-savoir"
              src="@/assets/newsletter-image-info.png"
              alt="image bon à savoir"
            />
          </div>
        </section>
        <section class="block-container">
          <div class="block-section">
            <h2>Historique à 10 ans</h2>
            <div style="width:380px;height:220px;">
              <canvas id="history-ca-chart" width="380" height="220"></canvas>
            </div>
          </div>
          <div class="block-section">
            <h2>&nbsp;</h2>
            <div style="width:380px;height:220px;">
              <canvas id="history-rfa-chart" width="380" height="220"></canvas>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import SubstituteAdh from "@/components/SubstituteAdh";
import DataBlock from "./DataBlock";
import Placeholder from "./Placeholder";

import { getAllMembersHierarchy, getAdhNewsletterData } from "@/utils/member";
import { getParameterByCode } from "@/utils/param";

export default {
  name: "Newsletter",
  components: {
    SubstituteAdh,
    DataBlock,
    Placeholder
  },
  data() {
    return {
      members: [],
      selectedMemberGuid: "",
      datas: {},
      chartCA: null,
      chartRFA: null,
      limitDates: ["01/01", "01/01", "01/01"]
    };
  },
  computed: {
    selectedMember() {
      if (!this.selectedMemberGuid) return this.me;
      return (
        this.members.find(el => el.Guid === this.selectedMemberGuid) || this.me
      );
    },
    nlInfos() {
      return this.datas && this.datas.data ? this.datas.data : {};
    }
  },
  methods: {
    showChartCA() {
      const canvas = document.getElementById("history-ca-chart");
      if (this.chartCA) this.chartCA.destroy();

      // Récupération des données pour afficher le graphique
      const labels = this.nlInfos.History.map(yearObj => {
        return yearObj.Year;
      });

      const data = this.nlInfos.History.map(yearObj => {
        return yearObj.CA;
      });

      this.chartCA = new Chart(canvas, {
        type: "line",
        data: {
          labels,
          datasets: [
            {
              data,
              label: "Variation CA",
              borderColor: "#8BC34A",
              backgroundColor: "#CBF38A",
              fill: false
            }
          ]
        },
        options: {
          legend: {
            display: true
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  callback: function(value, index, ticks) {
                    return value.toLocaleString("fr-FR", {
                      style: "currency",
                      currency: "EUR",
                      maximumFractionDigits: 0
                    });
                  }
                }
              }
            ]
          },
          cutoutPercentage: 80,
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                return (
                  " " +
                  data.labels[tooltipItem.index] +
                  " : " +
                  data.datasets[tooltipItem.datasetIndex].data[
                    tooltipItem.index
                  ].toLocaleString("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                    maximumFractionDigits: 0
                  })
                );
              }
            }
          },
          animation: {
            duration: 230
          }
        }
      });
    },
    showChartRFA() {
      const canvas = document.getElementById("history-rfa-chart");
      if (this.chartRFA) this.chartRFA.destroy();

      // Récupération des données pour afficher le graphique
      const labels = this.nlInfos.History.map(yearObj => {
        return yearObj.Year;
      });

      const data = this.nlInfos.History.map(yearObj => {
        return yearObj.TxRFA;
      });

      this.chartRFA = new Chart(canvas, {
        type: "line",
        data: {
          labels,
          datasets: [
            {
              data,
              label: "Variation RFA totale (en %)",
              borderColor: "#8BC34A",
              backgroundColor: "#CBF38A",
              fill: false
            }
          ]
        },
        options: {
          legend: {
            display: true
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  callback: function(value, index, ticks) {
                    return (value / 100).toLocaleString("fr-FR", {
                      style: "percent",
                      maximumFractionDigits: 2,
                      minimumFractionDigits: 2
                    });
                  }
                }
              }
            ]
          },
          cutoutPercentage: 80,
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                return (
                  " " +
                  data.labels[tooltipItem.index] +
                  " : " +
                  (
                    data.datasets[tooltipItem.datasetIndex].data[
                      tooltipItem.index
                    ] / 100
                  ).toLocaleString("fr-FR", {
                    style: "percent",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })
                );
              }
            }
          },
          animation: {
            duration: 230
          }
        }
      });
    }
  },
  watch: {
    selectedMember() {
      if (this.selectedMember.Level == 2 || this.selectedMember.Level == 3) {
        getAdhNewsletterData(this.selectedMemberGuid).then(res => {
          this.datas = res;
          this.showChartCA();
          this.showChartRFA();
        });
      }
    }
  },
  mounted() {
    getAllMembersHierarchy().then(res => {
      this.members = res.filter(m => m.Level <= 3);
    });
    getParameterByCode("NEWSLETTER_DATES").then(res => {
      this.limitDates = res.split(",");
    })
  }
};
</script>

<style scoped>
.newsletter-content {
  max-width: 1024px;
  background-color: #e5e7ed;
  --color: #8bc34a;
}

.newsletter-content h2 {
  color: var(--color);
  text-transform: uppercase;
  font-size: 1.2rem;
  font-weight: bold;
  margin: 0;
}

.newsletter-content section:not(:first-child) {
  padding: 16px;
}

.newsletter-content section:nth-child(2n) {
  background-color: #e5e7ed;
}

.newsletter-content section:nth-child(2n + 1) {
  background-color: #fff;
}

.header-img {
  max-width: 100%;
}

/* Styling blocs data CA/RFA annuel + acomptes */
.block-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 12px;
  row-gap: 12px;
}

.block-container .block-title {
  grid-column: span 2;
  margin-bottom: 12px;
}

@media (max-width: 800px) {
  .block-container {
    grid-template-columns: 1fr;
    justify-items: center;
  }
}

.block-container .block-section {
  min-width: calc(50% - 12px);
  margin-bottom: 12px;
}

.block-section .block-3-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 8px;
  width: 90%;
}

.block-section canvas {
  max-width: 80%;
  margin: auto;
}

/* Styling TOP 3 Familles/TOP 3 Frs */
.top-block-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 8px;
  justify-content: space-around;
  padding: 12px;
  max-width: 148px;
  text-align: center;
  background-color: #e5e7ed;
  margin-top: 6px;
}

.top-block-container .rank-progress {
  border-radius: 50%;
  text-align: center;
  width: min-content;
  aspect-ratio: 1 / 1;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.6rem;
  padding: 2px;
}

/* Styling données simulateur*/
table {
  background: transparent;
  border: 1px solid white;
  border-collapse: collapse;
  max-width: calc((1024px / 2) - 16px - 6px);
  margin-top: 6px;
}

table th,
table td {
  padding: 2px 4px;
}

table thead {
  background: white;
}

table tbody td {
  border: 1px solid white;
}

table tbody td:not(:first-child) {
  text-align: right;
}

.img-bon-a-savoir {
  max-width: 90%;
  margin: auto;
  height: 100%;
  object-fit: contain;
}

.color-primary {
  color: var(--color);
}

.green {
  color: var(--color);
}

.red {
  color: #c66;
}
</style>



// WEBPACK FOOTER //
// src/pages/Adherent/Newsletter/Newsletter.vue